<template>
  <div class="container" style="background: #fff">
    <div id="div_banner" class="banner1">
      <img src="../../assets/lianxi.png" alt="联系我们">
      <div>
        <p>联系我们</p>
        <span>Contact us</span>
      </div>
      <!--    <img v-if="imgUrl"  :src="baseUrl+imgUrl"  alt="新闻中心" height="190">-->
    </div>
    <div class="con1">
      <div class="box clearfix">
        <div class="left fl">
          <h2>联系我们</h2>
          <h3>CONTACT US</h3>
          <ul id="ul_contact">
            <li>地址：{{contactData.faddress}}</li>
            <li>电话：{{contactData.fphone}}</li>
            <li>邮箱：{{contactData.femail}}</li>
            <li>微信公众号：</li>
            <li class="img-box"><img :src="baseUrl + contactData.fwechatUrl" alt=""></li>
          </ul>
        </div>
        <div class="right">
          <h2>客户留言</h2>
          <h3>Feedback</h3>
          <div class="r_main">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm"  :inline="true" class="demo-form-inline">
              <el-form-item  prop="txtName" style="width: 300px;height: 50px">
                <el-input type="text" name="txtName" v-model="ruleForm.txtName" id="txtName" placeholder="姓名" class="in1 fl"></el-input>
              </el-form-item>
              <el-form-item  prop="txtTel" style="width: 300px;height: 50px">
                <el-input type="text" name="txtTel" id="txtTel" v-model="ruleForm.txtTel" placeholder="电话" class="in2 fr"></el-input>
              </el-form-item>
              <el-form-item  prop="txtEmail" style="width: 300px;height: 50px">
                <el-input type="text" name="txtEmail" id="txtEmail" v-model="ruleForm.txtEmail" placeholder="邮箱" class="in3 fl"></el-input>
              </el-form-item>
              <el-form-item  prop="txtAddress" style="width: 300px;height: 50px">
                <el-input  type="text" name="txtAddress" id="txtAddress" v-model="ruleForm.txtAddress" placeholder="地址" class="in4 fr"></el-input>
              </el-form-item>
              <el-form-item  prop="content" style="display: block" >
                <el-input type="textarea"  name="content" id="content" v-model="ruleForm.content" placeholder="反馈内容"></el-input>
              </el-form-item>
              <el-form-item >
                <el-button style="display: block" @click="submitBtn('ruleForm')">提交</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from '../../../static/js/commonAxios'
  export default {
    name: "contact",
    data(){
      let phone = (rule, value, callback) => {
        let ph= /^[1][3,4,5,7,8][0-9]{9}$/;
        if (!ph.test(value.toString().trim())) {
          return callback(new Error('请输入正确的手机号'));
        }else{ callback();}
      }
      return{
        ruleForm:{
          txtName:'',
          txtEmail:'',
          txtTel:'',
          txtAddress:'',
          content:'',
        },
        rules: {
          txtTel: [{ required: true, message: '请输入手机号码', trigger: 'blur' }, {validator:phone, trigger: 'change'}],
          txtName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
          txtEmail: [{ required: true, message: '请输入手机号码', trigger: 'blur' }, { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }],
          txtAddress:[{ required: true, message: '请输入地址', trigger: 'change' }],
          content: [{ required: true, message: '请输入反馈内容', trigger: 'change' }],
        },
        contactData:'',
        tip:'',
        baseUrl:''
      }
    },
    mounted() {
      this.baseUrl = process.env.API_ROOT;
      this.getContactData()
    },
    methods:{
      getContactData(){
        axios.get('/api/selectContactUsContent').then((res) => {
          if(res.data.success){
            this.contactData = res.data.items[0]
            console.log(this.contactData);
          }else{
            this.$message.error(res.data.msg)
          }
        })
      },
      submitBtn(formName){
        this.$refs[formName].validate((valid) => {
          if (valid) {
            axios.post(`/api/addFeedBack`, {
              "timestamp":new Date().getTime(),
              "sign": "string",
              "params": {
                "fname": this.ruleForm.txtName,
                "fphone": this.ruleForm.txtTel,
                "femail": this.ruleForm.txtEmail,
                "fcontent": this.ruleForm.content,
                "faddress": this.ruleForm.txtAddress,
              }
            }).then((res) => {
              if (res.data.success) {
                console.log(res);
                this.$message.success('感谢您的留言')
              }
            })
          } else {
            return false;
          }
        })
      }
    }


  }
</script>

<style scoped>
.img-box{
  width: 150px;
  height: 150px;
}
.img-box img{
  width: 100%;
}
  .con1{
    width: 100%;
    padding-top: 80px;
    padding-bottom: 80px;
  }
  .con1 .left{
    width: 350px;
  }
  .con1 .left h2{
    font-size: 24px;
    color: #333;
    margin-bottom: 10px;
  }
  .con1 .left h3{
    font-size: 14px;
    color: #666;
  }
  .con1 .left ul{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 55px;
    background: url(../../assets/59.png) no-repeat left bottom;
  }
  .con1 .left ul li{
    line-height: 30px;
    font-size: 14px;
    color:#333;
  }
  .con1 .left ul li img{
    margin-top: 10px;
  }
  .right{
    width: 650px;
    float: right;
  }
  .con1 .right h2{
    font-size: 24px;
    color: #333;
    margin-bottom: 10px;
  }
  .con1 .right h3{
    font-size: 14px;
    color: #666;
  }
  .con1 .right .r_main{
    width: 100%;
    margin-top: 30px;
  }
  .con1 .right .r_main a{
    width: 155px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    border: 1px solid #8ec31f;
    color: #8ec31f;
    font-size: 16px;
    display: block;
    margin-top: 30px;
    text-decoration: none;
  }

  .con1 .right .r_main a:hover{
    background: #8ec31f;
    color: #fff;
  }
  .con1 .right .r_main input{
    display: block;
    width: 223px;
    height: 48px;
    line-height: 48px;
    padding-left: 75px;
    margin-bottom: 20px;
    border: 1px solid #ccc;
    outline: none;
  }
  .con1 .right .r_main .in1{
    background: url(../../assets/47.png) no-repeat 20px center #f7f7f7;
  }

  .con1 .right .r_main .in2{
    background: url(../../assets/48.png) no-repeat 20px center #f7f7f7;
  }

  .con1 .right .r_main .in3{
    background: url(../../assets/49.png) no-repeat 20px center #f7f7f7;
  }

  .con1 .right .r_main .in4{
    background: url(../../assets/50.png) no-repeat 20px center #f7f7f7;
  }
  .con1 .right .r_main textarea{
    width: 598px;
    height: 120px;
    border: 1px solid #ccc;
    resize: none;
    padding-left: 50px;
    padding-top: 13px;
    background: url(../../assets/51.png) no-repeat 20px 10px #f7f7f7;
    outline: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/contact/contact.vue